import { render } from "./Anchor.vue?vue&type=template&id=f8c1ad90&scoped=true"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import "./Anchor.vue?vue&type=style&index=0&id=f8c1ad90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c1ad90"]])

export default __exports__